import { IconProps } from '@abstractTypes/icons'

export const BlackMetalsIcon = ({
  width = '1rem',
  height = '1rem',
  fill = 'none',
  stroke = '#333',
  className = '',
}: IconProps) => {
  return (
    <svg
      width={width}
      height={height}
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      stroke={stroke}
      className={className}
    >
      <circle cx={'50%'} cy={'50%'} r={'50%'} fill="url(#blackMetal)" />
      <defs>
        <linearGradient
          id="blackMetal"
          x1={47.85}
          y1={52.563}
          x2={7.612}
          y2={5.8}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.047} stopColor="#131313" />
          <stop offset={0.435} stopColor="#131313" stopOpacity={0.692} />
          <stop offset={0.646} stopColor="#131313" stopOpacity={0.4} />
          <stop offset={0.795} stopColor="#131313" stopOpacity={0.7} />
          <stop offset={1} stopColor="#131313" />
        </linearGradient>
      </defs>
    </svg>
  )
}
